import Vue from 'vue'
import Router from 'vue-router'
import ArticleList from '../components/ArticleList';
import Article from "../components/Article";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'ArticleList',
            component: ArticleList
        },
        {
            path: '/:index',
            name: 'ArticleList',
            component: ArticleList,
            props: true
        },
        {
            path: '/article/:slug',
            name: 'Article',
            component: Article,
            props: true
        }
    ]
})